import React, { useState } from "react";
import { EvtHeader } from "components/header";
import { invalidateAllQueries } from "utils/utils";
import LoggingDisciplineCard from "./components/cards/logging-discipline";
import ApprovalRateCard from "./components/cards/approval-rate";
import UtilizationCard from "./components/cards/utilization";
import TaskEfficiencyCard from "./components/cards/task-efficiency";
import TeamLoggingDisciplineCard from "./components/cards/team-logging-discipline";
import TeamApprovalRateCard from "./components/cards/team-approval-rate";
import TeamUtilizationCard from "./components/cards/team-utilization";
import JobExtensionScoreCard from "./components/cards/job-completion";
import BusinessGenerationCard from "./components/cards/business-generation";
import BillingDelayCard from "./components/cards/billing-delay";
import { selectUser } from "store/src/slices/auth-slice";
import { useSelector } from "react-redux";
import PerformanceDetailsSidebar from "./components/performance-details-sidebar";
import JCSurveyCardSection from "./components/cards/jc-survey";
import AMSurveyCardSection from "./components/cards/am-survey";
import MarginAdherenceCard from "./components/cards/margin-adherence";
import PerformanceOverviewFilters from "./components/filters";

export default function PerformanceOverview() {
  const { role } = useSelector(selectUser);
  const [selectedCard, setSelectedCard] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [tagId, setTagId] = useState(undefined);

  const handleTagChange = (newTagId) => {
    setTagId(newTagId);
    invalidateAllQueries();
  };

  const isJobCoordinator = role?.is_job_coordinator;
  const isAccountManager = role?.is_account_manager;
  const isDepartmentHead = role?.is_department_head;
  const isTeamLead = role?.is_teamlead;
  const isProjectCoordinator = role?.is_project_coordinator;
  const isMilestoneCoordinator = role?.is_milestone_coordinator;

  const handleCardClick = (cardData) => {
    console.log("cardData", cardData);
    setSelectedCard(cardData);
    setIsSidebarOpen(true);
  };

  const handleCloseSidebar = () => {
    setIsSidebarOpen(false);
    setSelectedCard(null);
  };

  const shouldShowcaseFunctionalSection =
    isJobCoordinator ||
    isAccountManager ||
    isDepartmentHead ||
    isTeamLead ||
    isProjectCoordinator ||
    isMilestoneCoordinator;

  return (
    <div className="w-full min-h-screen flex flex-col relative">
      <PerformanceOverviewFilters tagId={tagId} onChange={handleTagChange} />

      {/* Sections Wrapper */}
      <div className="flex-1">
        {/* Core Section - Individual Contributor Cards */}
        <div>
          <EvtHeader title={`Core`} />
          <div className="flex gap-4 px-4 lg:px-6 flex-wrap">
            <LoggingDisciplineCard tagId={tagId} onClick={handleCardClick} />
            <UtilizationCard tagId={tagId} onClick={handleCardClick} />
            <ApprovalRateCard tagId={tagId} onClick={handleCardClick} />
            <TaskEfficiencyCard tagId={tagId} onClick={handleCardClick} />
          </div>
        </div>

        {shouldShowcaseFunctionalSection && (
          <>
            {/* Functional Section - Role-based Cards */}
            <div>
              <EvtHeader title={`Functional`} />
              <div className="flex gap-4 px-4 lg:px-6  flex-wrap">
                {/* Job Management Cards (Job Coordinator, Project/Milestone Coordinators) */}
                {isJobCoordinator && (
                  <>
                    <JobExtensionScoreCard tagId={tagId} onClick={handleCardClick} />
                  </>
                )}

                {(isJobCoordinator || isAccountManager) && (
                  <>
                    <MarginAdherenceCard tagId={tagId} onClick={handleCardClick} />
                  </>
                )}

                {/* Account Management Cards (Account Manager) */}
                {isAccountManager && (
                  <>
                    <BusinessGenerationCard tagId={tagId} onClick={handleCardClick} />
                    <BillingDelayCard tagId={tagId} onClick={handleCardClick} />
                    {/* <ClientRetentionCard tagId={tagId} onClick={handleCardClick} /> */}
                  </>
                )}

                {/* Team Management Cards (Department Head, Team Lead, Project/Milestone Coordinators) */}
                {isDepartmentHead && (
                  <>
                    <TeamLoggingDisciplineCard tagId={tagId} onClick={handleCardClick} />
                    <TeamApprovalRateCard tagId={tagId} onClick={handleCardClick} />
                    <TeamUtilizationCard tagId={tagId} onClick={handleCardClick} />
                  </>
                )}
              </div>
            </div>
            <div>
              {isJobCoordinator && <JCSurveyCardSection tagId={tagId} onClick={handleCardClick} />}
              {isAccountManager && <AMSurveyCardSection tagId={tagId} onClick={handleCardClick} />}
            </div>
          </>
        )}
      </div>

      {/* Footer */}
      <div className="sticky bottom-0 w-full bg-muted py-3 text-center text-sm text-muted-foreground z-10 mt-8 shadow-sm">
        Provides an overview of performance from the past 12 months.
      </div>

      {/* Performance Details Sidebar */}
      <PerformanceDetailsSidebar
        isOpen={isSidebarOpen}
        onClose={handleCloseSidebar}
        cardData={selectedCard}
      />
    </div>
  );
}
